import React from 'react';
import { Loading } from '@brighterion/br-ui';
import { useSelector } from 'react-redux';
import Iframe from 'Components/Iframe';
import { appInfoSelector, getUser } from 'Selectors';
import { LOADED, GET_DECODED_TOKEN_SUCCESS, GET_DECODED_TOKEN_ERROR, PCI_VALUE_DECODED } from 'Utils';
import clsx from 'clsx';
import axios from 'axios';
import styles from './index.css';

type Props = {
    value: string;
    rowId: string;
};
const BcatsMaskedField = ({ value, rowId }: Props) => {
    const IFRAME_NAME = `${PCI_VALUE_DECODED}-${value}-${rowId}`;
    const iframeRef = React.useRef<HTMLIFrameElement>(null);
    const appInfo = useSelector(appInfoSelector);
    const { customerId } = useSelector(getUser);
    const [loaded, setLoaded] = React.useState(false);

    React.useEffect(() => {
        const listener = (e: MessageEvent) => {
            if (e.data) {
                const pData = e.data;
                if (pData?.name === IFRAME_NAME) {
                    switch (pData.type) {
                        case LOADED:
                            iframeRef.current?.contentWindow?.postMessage(
                                {
                                    type: 'INIT',
                                    payload: {
                                        jwt: axios.defaults.headers.common.Authorization,
                                        tenantId: customerId
                                    }
                                },
                                '*'
                            );
                            break;
                        case GET_DECODED_TOKEN_SUCCESS:
                            setLoaded(true);
                            break;
                        case GET_DECODED_TOKEN_ERROR:
                            setLoaded(true);
                            break;
                        default:
                            break;
                    }
                }
            }
        };
        window.addEventListener('message', listener);
        return () => {
            window.removeEventListener('message', listener);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className={styles.bcatsMaskedField}>
            {!loaded && <Loading size='sm' />}
            <Iframe
                ref={iframeRef}
                className={clsx(loaded && styles.showIframe)}
                name={IFRAME_NAME}
                id={IFRAME_NAME}
                src={`${appInfo!.pciComponentsURL}/tokens/${value}`}
            />
        </div>
    );
};

export default React.memo(BcatsMaskedField);
